import { useFetchQuantifyReport } from '@modules/quantify/hooks/useFetchQuantifyReport';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { useEffect, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { areInputsPresentInSearchParams } from '../utils';
import { useQuantifySessionStorage } from './useQuantifySessionStorage';
import { useSetQuantifyStoreFromSearchParams } from './useSetQuantifyStoreFromSearchParams';

interface UpdateStoreForNewQuantifyAnalysisOptions {
  shouldFetchChartData?: boolean;
  shouldFetchTableData?: boolean;
}

export const useUpdateStoreForNewQuantifyAnalysis = ({
  shouldFetchChartData = true,
  shouldFetchTableData = true,
}: UpdateStoreForNewQuantifyAnalysisOptions = {}) => {
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);
  const [isDataSetupDone, setIsDataSetupDone] = useState(false);

  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const fetchQuantifyReport = useFetchQuantifyReport({
    isInitialFetch: true,
    shouldFetchChartData,
    shouldFetchTableData,
  });

  const [setQuantifyStoreFromSearchParams, { isLoading }] =
    useSetQuantifyStoreFromSearchParams();

  const { setQuantifyStoreFromSessionStorage } = useQuantifySessionStorage();

  useEffect(() => {
    if (!isLoading) {
      if (areInputsPresentInSearchParams()) {
        setQuantifyStoreFromSearchParams();
      } else {
        setQuantifyStoreFromSessionStorage();
      }

      setShouldFetchReportData(true);
      setIsDataSetupDone(true);
    }
  }, [
    dispatch,
    setQuantifyStoreFromSessionStorage,
    setQuantifyStoreFromSearchParams,
    isLoading,
  ]);

  useUpdateEffect(() => {
    if (shouldFetchReportData) {
      fetchQuantifyReport().then(() => setShouldFetchReportData(false));
    }
  }, [shouldFetchReportData]);

  return { isDataSetupDone, isLoading };
};
